import Reveal from '../components/animation/Reveal';
import PageFrame from '../components/layout/PageFrame';
import ServiceCard from '../components/services/ServiceCard';
import { businessDetails, services } from '../data/siteContent';

function ServicesPage() {
  return (
    <PageFrame title="Services" eyebrow="What we offer">
      <div className="service-grid service-grid-page">
        {services.map((service, index) => (
          <ServiceCard key={service.title} service={service} headingLevel="h2" delay={index * 0.08} />
        ))}
      </div>
      <Reveal className="cta-strip">
        <h2>Need dishdasha tailoring in Qibla?</h2>
        <a className="primary-action" href={`https://wa.me/${businessDetails.phoneRaw}`}>WhatsApp {businessDetails.phone}</a>
      </Reveal>
    </PageFrame>
  );
}

export default ServicesPage;
